export default (value) => {
	return Math.ceil(value)
}



// WEBPACK FOOTER //
// ./src/filters/global/ceil.js